import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  TemplateRef,
  Type,
} from '@angular/core';
import {DialogRef} from './dialog-ref';

@Component({
  selector: 'tisa-dialog',
  styleUrls: ['./dialog.component.scss'],
  templateUrl: './dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DialogComponent {
  contentType: 'template' | 'string' | 'component' | undefined;

  content: string | TemplateRef<any> | Type<any> | undefined;

  get contentAsString(): string {
    return this.content as string;
  }

  get contentAsTemplate(): TemplateRef<any> {
    return this.content as TemplateRef<any>;
  }

  get contentAsType(): Type<any> {
    return this.content as Type<any>;
  }

  context: any | undefined;

  @HostBinding('class')
  get className(): string {
    const base =
      'flex fixed max-h-screen w-screen inset-0 justify-center items-end md:items-center md:p-4 lg:p-8';

    if (this._ref.closing) {
      return `${base} _closing`;
    }

    return base;
  }

  constructor(private readonly _ref: DialogRef) {}

  ngOnInit() {
    this.content = this._ref.content;

    if (typeof this.content === 'string') {
      this.contentType = 'string';
    } else if (this.content instanceof TemplateRef) {
      this.contentType = 'template';
      this.context = {
        close: this._ref.close.bind(this._ref),
      };
    } else {
      this.contentType = 'component';
    }
  }

  close(): void {
    this._ref.close();
  }
}
